<template>
  <hic-index-page v-if="permission.datacenter_data_query" title="网站地图">
    <BiVueMindmap ref="siteMap" :flatNodes="mapData" v-slot="{ id, parentId, orderNo, width, height, extra }" is-readonly>
      <el-row class="itemls" :title="getPage(id).memo">
        <b v-if="id == 'home'">首页</b>
        <b v-else>{{ id | dictText("WebPage") }}</b>
        <el-row v-if="permission.datacenter_setting_map" class="top-pad">
          <el-button @click="edit(id)" v-if="id != 'home'" type="primary" title="编辑" size="mini" icon="el-icon-edit" circle></el-button>
          <el-button @click="del(id)" v-if="id != 'home'" type="danger" title="删除" size="mini" icon="el-icon-delete" circle></el-button>
          <el-button @click="add(id)" type="success" title="添加" size="mini" icon="el-icon-plus" circle></el-button>
        </el-row>
      </el-row>
    </BiVueMindmap>
    <Select :parent="selectItem" :existed="items" :visible.sync="meta.showSelect" @close="page"></Select>
    <Editor v-model="entity" :visible.sync="meta.showEditor" @close="page"></Editor>
  </hic-index-page>
</template>
<script>
  import api from "@/common/api";
  import BiVueMindmap from "bi-vue-mindmap";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      Select: () => import("./select"),
      Editor: () => import("../page/edit"),
      BiVueMindmap,
    },
    data() {
      return {
        meta: {
          showSelect: false,
          loading: false,
          showEditor: false,
        },
        items: [],
        selectItem: {},
        entity: {},
      };
    },
    computed: {
      ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
      mapData() {
        return this.items.map((i) => ({ id: i.tgtCode, parentId: i.srcCode, title: i.tgtCode, isCustomized: true, width: i.width || 150, height: i.height || 100 }));
      },
    },
    mounted() {
      this.page();
    },
    methods: {
      getPage(code) {
        return this.dict.WebPage.find(p => p.code == code) || {}
      },
      getEntity(code) {
        return this.items.find((i) => i.tgtCode == code);
      },
      getChildren(code) {
        return this.items.filter((i) => i.srcCode == code).map((i) => ({ id: i.tgtCode, topic: i.tgtCode, children: this.getChildren(i.tgtCode) }));
      },
      edit(code) {
        api.Page.query({ keyword: code }).then((res) => {
          this.entity = res.items[0];
          this.meta.showEditor = true;
        });
      },
      page() {
        this.meta.loading = true;
        api.SiteMap.query({})
          .then((res) => {
            res.items.unshift({ tgtCode: "home", title: "首页", isCustomized: true, width: 100, height: 100 });
            this.$set(this, "items", res.items);
          })
          .catch((err) => {
            this.$message.error(err.message || err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      del(code) {
        let row = this.getEntity(code);
        if (this.items.filter((i) => i.srcCode == code).length > 0) return this.$message.error("此页面还有下级页面，禁止删除！");
        this.$confirm("确定要删除？", "确认", { type: "warning" })
          .then(() => {
            this.meta.loading = true;
            api.SiteMap.del(row.id)
              .then((res) => {
                this.page();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          })
          .catch((e) => {});
      },
      add(code) {
        this.selectItem = this.getEntity(code);
        this.meta.showSelect = true;
      },
    },
  };
</script>
<style scoped>
  .itemls {
    width: 110%;
    height: 110%;
    /* min-width: 80px; */
    /* max-width: 200px; */
    background-color: gray;
    color: white;
    border: 1px solid rgb(204, 204, 204);
    border-radius: 10px;
    -webkit-box-orient: vertical;
    margin-left: -0.2rem;
    padding-top: 15px;
    box-shadow: 5px 5px 5px #ccc;
    text-align: center;
  }
</style>
